import classNames from "classnames";
import { Alert } from "PFComponents/alert";
import { Typography } from "PFComponents/typography";

import css from "./errors_alert.module.scss";

type ErrorsAlertProps = {
  errors: {
    key: string;
    label: string;
    error?: string;
  }[];
  qaId?: string;
  className?: string;
};

export const ErrorsAlert = ({ errors, qaId, className }: ErrorsAlertProps) => (
  <Alert kind="error" qaId={qaId} className={classNames(css.root, className)}>
    {errors
      .filter(({ error }) => !!error)
      .map(({ key, label, error }) => (
        <Typography key={key} variant="bodyRegular">
          {label}: {error}
        </Typography>
      ))}
  </Alert>
);
